<template>
  <el-col :span="8">
    <el-card :body-style="{ padding: '5px', height: '500px' }">
      <div>
        <span>Cancer Type:</span>
        <el-select v-model="chooseCancer" placeholder="choose Cancer Type" clearable @change="selectCancer" size="mini">
          <el-option
              v-for="item in datasetName"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
      </div>
      <div>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dataset:</span>
        <el-select v-model="chooseDataset" placeholder="choose Dataset" clearable @change="getData" size="mini">
          <el-option
              v-for="item in dataset_result_list"
              :key="item.datasetID + '---' + item.name"
              :label="item.datasetname + '---' + item.name"
              :value="item.datasetID + '---' + item.name">
          </el-option>
        </el-select>
      </div>
      <div>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Type:</span>
        <el-select v-model="formData.Type"
                   clearable
                   filterable
                   size="mini"
                   @change="getFormateData"
                   placeholder="please select">
          <el-option
              v-for="item in immune_type"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
      </div>
      <div :id="myCardID" style="height: 400px;width: 400px"></div>
      <el-button type="text" style="margin: 0; padding: 0" @click="remove_son">remove</el-button>
    </el-card>
  </el-col>
</template>

<script>

import * as echarts from "echarts/core";

export default {
  name: 'ImmuneComponentCard',
  props:{
    cardID: Number
  },
  data(){
    return{
      datasetName: ['Breast Cancer', 'PDAC', 'SCC', 'Melanoma', 'Prostate Cancer', 'Liver Cancer', 'Ovarian Cancer', 'Glioblastoma',
        'Colorectal Cancer', 'Cervical Cancer', 'Bladder Cancer', 'Brain metastases', 'Lung Cancer', 'Head and neck Cancer'],
      chooseCancer: '',
      dataset_result_list: [],
      chooseDataset: '',
      immune_type: [],
      jsonData: {},
      selectTypeData: [],
      myCardID: '',
      formData: {
        datasetID: '',
        Array:  '',
        Type: ''
      },
      TLS_data: []
    }
  },
  mounted() {
    this.myCardID = 'TLSCardViolin' + this.cardID
    this.$nextTick( () => {
      this.initEcharts()
    })
  },
  methods:{
    remove_son(){
      this.$emit("remove_father", this.cardID);
    },
    selectCancer(){
      let _this = this
      // console.log(_this.chooseCancer)
      _this.chooseDataset = ''
      _this.$axios.get(
          'http://' + _this.$global.serverIP + ':' + _this.$global.serverHost + '/datasets/' + _this.chooseCancer)
          .then(function (response) {
            _this.dataset_result_list = response.data
          })
    },
    initEcharts(){
      let _this = this
      let _div = document.getElementById(_this.myCardID);
      let myChart = this.$echarts.getInstanceByDom(_div);
      if (myChart == null) {
        myChart = echarts.init(_div);
      }
      // const chartDom = document.getElementById('dataset_immune_main');
      // const myChart = echarts.init(chartDom);
      let option;
      const schema = [
        { name: 'no', index: 0, text: 'no' },
        { name: 'x', index: 1, text: 'x' },
        { name: 'y', index: 2, text: 'y' },
        { name: 'spot', index: 3, text: 'spot' },
        { name: 'score', index: 4, text: 'score' },
      ];
      const itemStyle = {
        emphasis: {
          focus : 'self'
        }
      };
      option = {
        title:{
          text: "Celltype AddModuleScore",
          left: 'center'
        },
        color: ['#FF0000', '#FF8000', '#FFFF00', '#80FF00', '#00FF00', '#00FF80', '#00FFFF',
          '#0080FF', '#0000FF', '#7F00FF', '#FF00FF', '#FF007F', '#808080', '#FF7F7F'],
        toolbox: {
          show: true,
          top: 20,
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage: {
              show: true,
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        legend: {
          x: 'center',
          y: 'top',
          textStyle: {
            fontWeight: 'bold',
            color: 'red',
            fontSize: 10
          }
        },
        grid: {
          right: 100,
        },
        tooltip: {
          backgroundColor: 'rgba(255,255,255,0.7)',
          formatter: function (param) {
            // console.log(param)
            var value = param.value;
            // prettier-ignore
            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                + _this.formData.type
                + '</div>'
                // + schema[0].text + '：' + value[2] + '<br>'
                + schema[1].text + ': ' + value[0] + '<br>'
                + schema[2].text + ': ' + value[1] + '<br>'
                + schema[3].text + ': ' + value[3] + '<br>'
                + schema[4].text + ': ' + value[4] + '<br>';
          }
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        visualMap: [
          {
            left: 'right',
            bottom: '30%',
            dimension: 4,
            type: 'continuous',
            calculable:true,                        //是否显示拖拽用的手柄（手柄能拖拽调整选中范围）
            realtime:true,                          //拖拽时，是否实时更新
            precision:3,                            //数据展示的小数精度，默认为0，无小数点
            min: 0,
            max: 1,
            itemHeight: 120,
            align:"auto",
            text: ['score'],
            textGap: 30,
            inRange: {
              // colorLightness: [1, 0.4],
              color: ['#d9d9d9','blue']
            },
            outOfRange: {
              color: ['rgba(255,255,255,0.4)']
            },
            controller: {
              inRange: {
                color: ['#d9d9d9','blue']
                // color: ['#c23531']
                // color: ['#FFFFFF']
              },
              outOfRange: {
                color: ['#999']
              }
            }
          }
        ],
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        series: [
          {
            type: 'scatter',
            itemStyle: itemStyle,
            large: true,                //是否开启大规模散点图的优化，在数据图形特别多的时候（>=5k）可以开启。开启后配合 largeThreshold 在数据量大于指定阈值的时候对绘制进行优化。缺点：优化后不能自定义设置单个数据项的样式。
            largeThreshold:5000,        //开启绘制优化的阈值。
            data: [],
            symbolSize: 3,
          },
        ]
      };
      option && myChart.setOption(option);
    },
    getData(data){
      let _this = this
      _this.formData.datasetID = data.split("---")[0]
      _this.formData.Array = data.split("---")[1]
      // console.log(_this.formData.datasetID+" "+_this.formData.Array)
      // console.log(resolve,reject)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/immune/'+ _this.formData.datasetID
          +'/'+ _this.formData.Array)
          .then(function (res) {
            _this.jsonData = res.data
            let name = Object.keys(_this.jsonData[0])
            let new_set = new Set(name)
            new_set.delete('x')
            new_set.delete('y')
            new_set.delete('spot')
            _this.immune_type = Array.from(new_set)
            _this.formData.type = _this.immune_type[0]
            _this.getFormateData()
          })

    },
    getFormateData(){
      let _this = this
      _this.selectTypeData.length = 0
      for (let i = 0; i < _this.jsonData.length; i++) {
        let item = _this.jsonData[i]
        let temp = [item.x, item.y, i+1, _this.formData.Type, item[[_this.formData.Type]]]
        _this.selectTypeData.push(temp)
      }
      // console.log(_this.selectTypeData)
      _this.changeSelect()
    },
    changeSelect() {
      let _this = this
      const myChart = echarts.getInstanceByDom(document.getElementById(_this.myCardID));
      let option;
      const itemStyle = {
        emphasis: {
          focus : 'self'
        }
      };
      myChart.setOption({
        series: [
          {
            type: 'scatter',
            itemStyle: itemStyle,
            large: true,                //是否开启大规模散点图的优化，在数据图形特别多的时候（>=5k）可以开启。开启后配合 largeThreshold 在数据量大于指定阈值的时候对绘制进行优化。缺点：优化后不能自定义设置单个数据项的样式。
            largeThreshold:5000,        //开启绘制优化的阈值。
            data: _this.selectTypeData,
            symbolSize: 3,
          },
        ]
      })
      // chartDom.setAttribute('_echarts_instance_', '')
      option && myChart.setOption(option,true);
    },
  }
};
</script>
